module.exports = __webpack_public_path__ + "img/undraw_feedback_h2ft.ebdd9176.svg";